/**
 * Archivo: ComunicadosServicios.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este fichero contiene las funciones para interactuar con la API de comunicados. 
 * Incluye funciones para listar, añadir, actualizar, eliminar y descargar PDFs de comunicados.
 * 
 * Propósito:
 * Proveer funciones para gestionar los datos de los comunicados, incluyendo su interacción con la base de datos a través del backend.
 */
const API = process.env.REACT_APP_API_BASE_URL; 

// Función para obtener los comunicados de la base de datos
export const listaComunicados = async (token) => {
    const urlComunicados = `${API}/api/comunicados`;

    try {
        const response = await fetch(urlComunicados, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
  
        const data = await response.json();
        if (data.message === 'OK') {
            return { success: true, data: data.body };
        } else {
            return { success: false, message: data.message };
        }
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
  };
  
  // Función para añadir un comunicado a la base de datos
  export const añadirComunicado = async (token, formData) => {
    const urlAddComunicado = `${API}/api/comunicados`;
    try {
        const response = await fetch(urlAddComunicado, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });
  
        const data = await response.json();
        if (data.success) {
            return { success: true, data: data.data };
        } else {
            return { success: false, message: data.message };
        }
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
  };
  
  // Función para actualizar un comunicado
  export const actualizarComunicado = async (token, formData) => {
    const urlUpdateComunicado = `${API}/api/comunicados`;
    try {
        const response = await fetch(urlUpdateComunicado, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });
  
        const data = await response.json();
        if (data.success) {
            return { success: true, data: data.data };
        } else {
            return { success: false, message: data.message };
        }
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
  };
  
  // Función para eliminar un comunicado
  export const eliminarComunicado = async (token, id_comunicado) => {
    const urlEliminarComunicado = `${API}/api/comunicados`;
  
    try {
        const response = await fetch(urlEliminarComunicado, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ id_comunicado }),
        });
  
        const data = await response.json();
        if (data.success) {
            return { success: true, data: data.data };
        } else {
            return { success: false, message: data.message };
        }
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
  };
  
  // Función para descargar el PDF del comunicado
  export const descargarComunicadoPDF = async (token, id_comunicado) => {
    const urlDescargarPDF = `${API}/api/comunicados/descargarPDF`;

    try {
        const response = await fetch(urlDescargarPDF, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ id_comunicado }),
        });
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message };
        }
  
        const blob = await response.blob();
        return { success: true, data: blob };
    } catch (error) {
        return { success: false, message: 'Error al descargar PDF' };
    }
  };
  
  